// Global search dropdown: one headed section per type (Staff, Partner users, Customer users, Partners,
// Customers, Apps), top 5 each, with "See all" opening the full list on that type's page.
import { AppWindow, Building2, ChevronRight, Handshake, UserCog, Users } from "lucide-react";

const META = {
  staff_users:    { icon: UserCog,   all: (q) => `/settings?tab=staff&q=${q}` },
  partner_users:  { icon: Users,     all: (q) => `/partners?q=${q}` },
  customer_users: { icon: Users,     all: (q) => `/customers?q=${q}` },
  partners:       { icon: Handshake, all: (q) => `/partners?q=${q}` },
  customers:      { icon: Building2, all: (q) => `/customers?q=${q}` },
  apps:           { icon: AppWindow, all: (q) => `/apps?q=${q}` },
};

const idOf = (key, it) => (key === "apps" ? it.app_id : key.endsWith("_users") ? it.user_id : it.org_id);
const subOf = (key, it) => (key === "staff_users" ? it.email : key.endsWith("_users") ? it.organization_name || it.email : "");

function Section({ g, q, onPick, onAll }) {
  const { icon: Icon, all } = META[g.key] || META.apps;
  return (
    <div className="py-1" data-testid={`search-group-${g.key}`}>
      <div className="flex items-center justify-between px-2 pb-1 pt-1.5">
        <span className="text-[10px] font-semibold uppercase tracking-[0.14em] text-slate-400">{g.label}</span>
        <span className="rounded-full bg-slate-100 px-1.5 text-[10px] font-semibold text-slate-500" data-testid={`search-group-count-${g.key}`}>{g.total}</span>
      </div>
      {g.items.map((it) => {
        const id = idOf(g.key, it);
        const sub = subOf(g.key, it);
        return (
          <button key={id} type="button" onClick={() => onPick(g.key, it)} data-testid={`search-result-${g.key}-${id}`}
            className="flex w-full items-center gap-2 rounded px-2 py-1.5 text-left text-sm transition-colors hover:bg-slate-50">
            <Icon className="h-4 w-4 shrink-0 text-slate-400" />
            <span className="truncate text-slate-800">{it.name}</span>
            {sub && <span className="ml-auto truncate pl-2 text-xs text-slate-400">{sub}</span>}
          </button>
        );
      })}
      {g.total > g.items.length && (
        <button type="button" onClick={() => onAll(all(encodeURIComponent(q.trim())))} data-testid={`search-see-all-${g.key}`}
          className="flex w-full items-center gap-1 rounded px-2 py-1 text-left text-xs font-medium text-[#206bc4] transition-colors hover:bg-blue-50">
          See all {g.total} <ChevronRight className="h-3 w-3" />
        </button>
      )}
    </div>
  );
}

export function GlobalSearchResults({ results, q, onPick, onAll }) {
  const groups = (results.groups || []).filter((g) => g.total > 0);
  return (
    <div className="absolute z-50 mt-2 max-h-[70vh] w-[26rem] overflow-y-auto rounded-lg border border-slate-200 bg-white p-2 shadow-lg"
         data-testid="global-search-results">
      {!groups.length && <div className="px-2 py-3 text-sm text-slate-400" data-testid="global-search-empty">No results</div>}
      <div className="divide-y divide-slate-100">
        {groups.map((g) => <Section key={g.key} g={g} q={q} onPick={onPick} onAll={onAll} />)}
      </div>
    </div>
  );
}
